export const APP_LIST_REQUEST = "APP_LIST_REQUEST"; 
export const APP_LIST_SUCCESS = "APP_LIST_REQUEST_SUCCESS"; 
export const APP_DETAIL_REQUEST = "APP_DETAIL_REQUEST"; 
export const APP_INSTALL_REQUEST = "APP_INSTALL_REQUEST"; 

export const READ_APP = 225000;
export const INSTALL_APP_CODE = 225011;
export const UNINSTALL_APP_CODE = 225012;